<template>
  <div class="showWrap">
    <!-- header -->
    <Header />

    <!-- 详情 -->
    <div class="show">
      <div class="w1200">
        <!-- 新闻详情 -->
        <div v-if="newsFlag">
          <h2>{{detailData.name}}</h2>
          <p class="releaseTime">{{detailData.releaseTime}}</p>
          <div class="content">
            <img v-for="(item, index) in imgList"
            :key="index" 
            :src="origin + item" 
            :alt="detailData.name">
            <!-- {{detailData.content}} -->
            <p v-for="remark in detailData.content.split('。')" :key="remark">
                {{remark}}。
            </p>
          </div>
        </div>

        <!-- 资质详情 -->
        <div v-if="qualificationFlag">
          <h2>{{detailData.name}}</h2>
          <p>{{detailData.createDate}}</p>
          <div class="remarks">
            <img v-for="(item, index) in imgList"
            :key="index" 
            :src="origin + item" 
            :alt="detailData.name">
            {{detailData.remarks}}

            <div class="iconfont prev icon-fanhui" @click="prevQualification(--qualificationId)"></div>
            <div class="iconfont next icon-arrow-right-ico" @click="nextQualification(++qualificationId)"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端 -->
    <div class="show_mobile">
      <!-- 新闻详情 -->
      <div v-if="newsFlag">
        <h2>{{detailData.name}}</h2>
        <p class="releaseTime">{{detailData.releaseTime}}</p>
        <div class="content">
          <img v-for="(item, index) in imgList"
          :key="index" 
          :src="origin + item" 
          :alt="detailData.name">
          <!-- {{detailData.content}} -->
          <p v-for="remark in detailData.content.split('。')" :key="remark">
            {{remark}}。
          </p>
        </div>
      </div>

      <!-- 资质详情 -->
      <div v-if="qualificationFlag">
        <h2>{{detailData.name}}</h2>
        <p>{{detailData.createDate}}</p>
        <div class="remarks">
          <img v-for="(item, index) in imgList"
          :key="index" 
          :src="origin + item" 
          :alt="detailData.name">
          {{detailData.remarks}}
        </div>
      </div>
    </div>

    <!-- footer -->
    <Footer />
  </div>
</template>

<script>
import { NewsFeedDetail, QualificationDetail, Qualification } from '@/api/http';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      origin: '',
      newsFlag: false,
      qualificationFlag: false,
      detailData: {},
      imgList: [],
      count: parseInt(this.$route.params.count),
      qualificationId: this.$route.params.pageNo
    }
  },
  created() {
    switch(this.$route.params.type) {
      case 'news': 
        // 加载新闻详情
        this.getNewsFeedDetail(this.$route.params.id);
        break;
      case 'certification':
        // 加载资质详情
        this.getQualificationDetail(this.$route.params.id);
        break;
    }
  },
  methods: {
    // 获取新闻详情
    getNewsFeedDetail(id) {
      NewsFeedDetail(id)
      .then(res => {
        // console.log(res);
        this.newsFlag = true;
        this.qualificationFlag = false;
        this.origin = this.$origin;
        this.detailData = res.data[0];
        this.imgList = res.data[0].imgUrl.split('|');
        // console.log(this.imgList);
      })
      .catch(err => {
        console.log('数据加载失败，请稍后重试');
      })
    },

    // 获取资质详情
    getQualificationDetail(id) {
      QualificationDetail(id)
      .then(res => {
        this.newsFlag = false;
        this.qualificationFlag = true;
        // console.log(res);
        this.origin = this.$origin;
        this.detailData = res.data[0];
        this.imgList = res.data[0].imgUrl.split('|');
        // console.log(this.imgList);
      })
      .catch(err => {
        console.log('数据加载失败，请稍后重试');
      })
    },
    
    // 上一条资质
    prevQualification(qualificationId) {
      if(qualificationId <= 1) {
        this.qualificationId = 1;
        // console.log(this.qualificationId);
      }
      Qualification({
        pageNo: qualificationId <= 1 ? 1 : qualificationId,
        pageSize: 1,
      })
      .then((res) => {
        this.newsFlag = false;
        this.qualificationFlag = true;
        // console.log(res);
        this.origin = this.$origin;
        this.detailData = res.data.list[0];
        this.imgList = res.data.list[0].imgUrl.split('|');
      })
      .catch(err => {
        console.log('数据加载失败，请稍后重试');
      })
    },

    // 下一条资质
    nextQualification(qualificationId) {
      if(qualificationId >= this.count) {
        this.qualificationId = this.count;
        // console.log(this.qualificationId);
      }
      Qualification({
        pageNo: qualificationId >= this.count ? this.count : qualificationId,
        pageSize: 1,
      })
      .then((res) => {
        this.newsFlag = false;
        this.qualificationFlag = true;
        // console.log(res);
        this.origin = this.$origin;
        this.detailData = res.data.list[0];
        this.imgList = res.data.list[0].imgUrl.split('|');
      })
      .catch(err => {
        console.log('数据加载失败，请稍后重试');
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/show';
</style>